// extracted by mini-css-extract-plugin
export default {"right":"MortgageStepCardMobile_right__6SsUA","left":"MortgageStepCardMobile_left__jc0YU","textMortgageStepMobile":"MortgageStepCardMobile_textMortgageStepMobile__y9f3V"};